import { NavLink } from "react-router-dom";

export interface NavItem {
  to: string;
  label: string;
}

export interface NavProps {
  items?: NavItem[];
  /** Rechts in der Pille, z. B. der Anmeldestatus. */
  trailing?: React.ReactNode;
}

/**
 * Schwebende Navigationspille.
 *
 * Sie sitzt mit Abstand unterhalb des Viewport-Rands statt buendig oben --
 * das ist die auffaelligste Geste des Design-Systems und bleibt ueber alle
 * Breakpoints erhalten.
 *
 * Airspace hat sehr wenige Ansichten. Die Pille bleibt deshalb auch auf
 * Mobilgeraeten ohne Hamburger-Menue lesbar; ein Menue fuer zwei Eintraege
 * waere mehr Bedienschritt als Nutzen.
 */
export function Nav({ items = [], trailing }: NavProps): React.ReactElement {
  return (
    <nav className="nav" aria-label="Hauptnavigation">
      <NavLink to="/" className="nav__brand">
        Airspace
      </NavLink>

      {items.length > 0 ? (
        <ul className="nav__links">
          {items.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} className="nav__link">
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      ) : null}

      {trailing ? <div>{trailing}</div> : <div aria-hidden="true" />}
    </nav>
  );
}
